<template>
    <application-modal v-model="cancelPlanModal">
        <v-btn
            data-testid="open-cancel-btn"
            class="open-cancel-btn error large white--text pl-3 pr-4"
            block
            slot="modal-trigger"
            @click.stop="openCancelModal"
        >
            <v-icon class="mr-2">cancel</v-icon>
            Cancel Plan
        </v-btn>

        <div
            slot="modal-title"
            data-testid="plan-title"
        >
            Cancel {{ planType }}
        </div>

        <div slot="modal-body" style="min-height: 4rem">
            <v-layout align-start class="my-4">
                <v-layout column class="subheading" style="width: 650px">
                    <v-layout class="mx-2 my-1">
                        <v-flex data-testid="confirm-cancellation-text">
                            Are you sure you want to delete this {{ planType }}? Once you cancel you will need to create a new {{ planType }}.
                        </v-flex>
                    </v-layout>
                </v-layout>
            </v-layout>
        </div>

        <v-btn
            data-testid="confirm-cancellation-btn"
            class="confirm-cancellation-btn primary"
            slot="create-button"
            :loading="loading"
            @click.native="cancelPlan"
        >
            Confirm
        </v-btn>
    </application-modal>
</template>

<script>

import ApplicationModal from "@/components/ApplicationModal";
export default {
  name: "CancelPaymentPromise",
  components: {
    ApplicationModal
  },

  props: {
    isPlans: {
      type: Boolean,
      default: false
    },
    planId: {
      type: [Number, String],
      default: ""
    }
  },

  data() {
    return {
      cancelPlanModal: false,
      loading: false
    };
  },

  methods: {
    openCancelModal() {
      this.cancelPlanModal = true;
    },

    cancelPlan() {
      this.isPlans ? this.handlePaymentPlan(this.planId) : this.handlePromiseToPay(this.planId);
    },

    handlePaymentPlan() {
      this.loading = true;
      this.$store.dispatch("cancelPaymentPlan", this.planId)
        .then(() => {
          this.$store.dispatch("handleSuccess", this.planType + " cancelled successfully.");
          this.getAllPaymentPlans();
          this.getLedgerInfo();
          this.loading = false;
          this.cancelPlanModal = false;
        })
        .catch(err => {
          this.$store.dispatch("handleError", err);
          this.loading = false;
        });
    },

    handlePromiseToPay() {
      this.loading = true;
      this.$store.dispatch("cancelPromiseToPay", this.planId)
        .then(() => {
          this.$store.dispatch("handleSuccess", this.planType + " cancelled successfully.");
          this.getAllPromiseToPays();
          this.getLedgerInfo();
          this.loading = false;
          this.cancelPlanModal = false;
        })
        .catch(err => {
          this.$store.dispatch("handleError", err);
          this.loading = false;
        });
    },

    getAllPaymentPlans() {
      let payload = {
        facilityId: this.$route.params.facilityId,
        tenantId: this.$route.params.tenantId
      };

      this.$store.dispatch("getAllPaymentPlansForTenant", payload)
        .catch(err => {
          this.$store.dispatch("handleError", err);
        });
    },

    getAllPromiseToPays() {
      let payload = {
        facilityId: this.$route.params.facilityId,
        tenantId: this.$route.params.tenantId
      };

      this.$store.dispatch("getAllPromisesToPayForTenant", payload)
        .catch(err => {
          this.$store.dispatch("handleError", err);
        });
    },

    getLedgerInfo() {
      this.loading = true;
      const ledgerPayload = {
        facilityId: this.$route.params.facilityId,
        tenantId: this.$route.params.tenantId
      };

      this.$store.dispatch("getLedgerInfo", ledgerPayload)
        .then(() => {
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          this.$store.dispatch("handleError", err);
        });
    }
  },

  computed: {
    planType() {
      return this.isPlans ? "Payment Plan" : "Promise-to-Pay";
    }
  }
};
</script>
